import { render, staticRenderFns } from "./medicalrecord.vue?vue&type=template&id=a99631fc&scoped=true"
import script from "./medicalrecord.vue?vue&type=script&lang=js"
export * from "./medicalrecord.vue?vue&type=script&lang=js"
import style0 from "./medicalrecord.vue?vue&type=style&index=0&id=a99631fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99631fc",
  null
  
)

export default component.exports